import cross from '~/assets/icons/cross.svg';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import {
	setAuctionCategorySelectVisible,
	setAuctionCreateCategory,
	setAuctionItemSelectVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	AppAuctionFilter,
	AppAuctionTypes,
	appAuctionFilterButtons,
} from '../AppAuction/AppAuction.model';
import {
	StyledCategories,
	StyledCategory,
	StyledCloseButtonWrap,
	StyledContainer,
} from './AppAuctionCategorySelect.styled';

const auctionCategorySelectLabels: Record<AppAuctionTypes, string> = {
	[AppAuctionTypes.Realty]: 'Недвижимость',
	[AppAuctionTypes.Vehicle]: 'Транспорт',
	[AppAuctionTypes.Clothes]: 'Одежда',
	[AppAuctionTypes.Bussiness]: 'Бизнес',
};

const auctionCategorySelectOrder: AppAuctionTypes[] = [
	AppAuctionTypes.Realty,
	AppAuctionTypes.Vehicle,
	AppAuctionTypes.Clothes,
	AppAuctionTypes.Bussiness,
];

const AppAuctionCategorySelect = () => {
	const dispatch = useLayoutDispatch();
	const createCategory = useLayoutSelector(
		(state) => state.auction.createCategory,
	);

	const handleClose = () => {
		dispatch(setAuctionCategorySelectVisible(false));
	};

	return (
		<StyledContainer>
			<Text style={{ fontSize: 14, color: '#ffffff', opacity: 0.25 }}>
				Выберите категорию
			</Text>
			<StyledCategories>
				{auctionCategorySelectOrder.map((item) => {
					const meta =
						appAuctionFilterButtons[item as unknown as AppAuctionFilter];

					return (
						<StyledCategory
							$active={item === createCategory}
							key={item}
							onClick={() => {
								dispatch(setAuctionCreateCategory(item));
								dispatch(setAuctionCategorySelectVisible(false));
								dispatch(setAuctionItemSelectVisible(true));
							}}
						>
							<img src={meta.icon} />
							<Text>{auctionCategorySelectLabels[item]}</Text>
						</StyledCategory>
					);
				})}
			</StyledCategories>
			<StyledCloseButtonWrap>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					borderRadius={ButtonBorderRadius.Radius10}
					square
					onClick={handleClose}
				>
					<img width={14} height={14} src={cross} alt="" />
				</Button>
			</StyledCloseButtonWrap>
		</StyledContainer>
	);
};

export { AppAuctionCategorySelect };
